import { Language, isValidLanguage } from '@/utils/language'
import { Currency, isValidCurrency, isValidSecondaryCurrency, SecondaryCurrency } from '@/utils/currency'
import { Region, isValidRegion } from '@/utils/region'

const generateCookies = async ({
  acceptLanguage = '',
  languageFromCookie = '',
  currencyFromCookie = '',
  secondaryCurrencyFromCookie = '',
  regionFromCookie = '',
  token = ''
}) => {
  const defaultLanguage = acceptLanguage.startsWith(Language.zhCN) ? Language.zhCN : Language.enUS
  const language = isValidLanguage(languageFromCookie) ? languageFromCookie : defaultLanguage
  const currency = isValidCurrency(currencyFromCookie) ? currencyFromCookie : Currency.US
  const secondaryCurrency = isValidSecondaryCurrency(secondaryCurrencyFromCookie)
    ? secondaryCurrencyFromCookie
    : SecondaryCurrency.CN
  const region = isValidRegion(regionFromCookie) ? regionFromCookie : Region.US

  return {
    language,
    currency,
    secondaryCurrency,
    region
  }
}

export default generateCookies
